import React, { useState } from "react";
import MarketingDocGate from "../MarketingDocGate";
import { lengthError, targetError } from "../../utils/validation";

import CTAForm from "../components/CTAForm";
import CTAPreview from "../components/CTAPreview";
import CTASummary from "../components/CTASummary";

function CTAConfiguration({ initial: savedConfig = {}, onSave }) {

  const [ctaName, setCtaName] = useState(savedConfig.ctaName || "Book a Demo");

  const [buttonLabel, setButtonLabel] =
    useState(savedConfig.buttonLabel || "Book a Demo");

  const [actionType, setActionType] =
    useState(savedConfig.actionType || "Booking Page");

  const [destination, setDestination] =
    useState(savedConfig.destination || "/book-demo");

  const [isActive, setIsActive] =
    useState(savedConfig.isActive ?? true);

  const [error, setError] =
    useState("");

  const [saved, setSaved] =
    useState(false);


  const handleSave = async (event) => {

    event.preventDefault();

    setError("");
    setSaved(false);


    const problem =
      lengthError(ctaName, { min: 2, max: 60, label: "CTA name" }) ||
      lengthError(buttonLabel, { min: 2, max: 30, label: "Button label" }) ||
      targetError(destination);
    if (problem) {
      setError(problem);
      return;
    }

    try {
      await onSave({ ctaName, buttonLabel, actionType, destination, isActive });
      window.dispatchEvent(new CustomEvent('chatbizz_cta_updated'));
      setSaved(true);
    } catch (saveError) {
      setError(saveError.message || "Unable to save the CTA.");
    }

  };


  const handleCancel = () => {

    setCtaName("Book a Demo");

    setButtonLabel("Book a Demo");

    setActionType("Booking Page");

    setDestination("/book-demo");

    setIsActive(true);

    setError("");

    setSaved(false);

  };


  return (

    <div className="cta-page">

      {/* Page Header */}

      <div className="page-header">

        <div>

          <h2>
            CTA Configuration
          </h2>

          <p>
            Create and configure call-to-action
            buttons for visitor conversations.
          </p>

        </div>


        <span
          className={
            isActive
              ? "badge bg-success"
              : "badge bg-secondary"
          }
        >
          {isActive
            ? "Active"
            : "Inactive"
          }
        </span>

      </div>


      <div className="row g-4">

        {/* Form */}

        <div className="col-lg-8">

          <CTAForm

            ctaName={ctaName}
            setCtaName={setCtaName}

            buttonLabel={buttonLabel}
            setButtonLabel={setButtonLabel}

            actionType={actionType}
            setActionType={setActionType}

            destination={destination}
            setDestination={setDestination}

            isActive={isActive}
            setIsActive={setIsActive}

            onSave={handleSave}
            onCancel={handleCancel}

            error={error}
            saved={saved}

          />

        </div>


        {/* Preview */}

        <div className="col-lg-4">

          <CTAPreview
            buttonLabel={buttonLabel}
            isActive={isActive}
          />


          <CTASummary
            ctaName={ctaName}
            actionType={actionType}
            isActive={isActive}
          />

        </div>

      </div>

    </div>

  );
}

export default function CTAConfigurationPage() {
  return <MarketingDocGate section="cta">{({ doc, save }) => <CTAConfiguration initial={doc} onSave={save} />}</MarketingDocGate>;
}